import {
  Monthly_Care_Statement_SubSections,
  Nutritional_SubSections,
  Resident_Of_The_Day_SubSections,
  Sections,
  SubSections,
  UpdatePriorities,
  Wound_Care_SubSections,
  Social_SubSections,
  Vaccination_SubSections
} from './../updateSchema/updateFormModels';
import {
  Medication_Incidents_SubSections,
  Other_SubSections,
  Pain_SubSections,
  Return_From_Hospital_SubSections,
} from "../updateSchema/updateFormModels";
import { IMainUpdateForm } from '../updateTab';

export function isSectionHasSubsection(section: Sections) {
  return section !== Sections.Medication_Incidents && 
         section !== Sections.Pain &&
         section !== Sections.Vaccination &&
         section !== Sections.Other &&
         section !== Sections.Return_From_Hospital &&
         section !== Sections.Nutritional &&
         section !== Sections.Resident_Of_The_Day &&
         section !== Sections.Social &&
         section !== Sections.Monthly_Care_Statement
}

export function isUpdateHasCustomName(section: Sections | '') {
  return section === Sections.Other || section === Sections.Social;
}

export function isUpdateHighPriority(priority: UpdatePriorities | "") {
  return priority === UpdatePriorities.High;
}


export enum PhoneCall {
  HAS_BEEN_CALLED = 'has_been_called',
  ATTEMPTED_TO_CALL = 'attempted_to_call',
  CONTACT_VISITING_HOME = 'contact_visiting_home',
  NOT_REQUIRED = 'not_required',
}

export const PhoneCallRadioNames = {
  [PhoneCall.HAS_BEEN_CALLED]: "A family contact was called and an update provided over the phone",
  [PhoneCall.ATTEMPTED_TO_CALL]: "No answer to phone call - called family contact and couldn't reach them",
  [PhoneCall.CONTACT_VISITING_HOME]: "Family contact visiting home - an update provided in person",
  [PhoneCall.NOT_REQUIRED]: "Phone call not required",
}

export const PhoneCallInputLabels = {
  [PhoneCall.HAS_BEEN_CALLED]: "Write name of family member you have called",
  [PhoneCall.ATTEMPTED_TO_CALL]: "Write name of family member you have called",
  [PhoneCall.CONTACT_VISITING_HOME]: "Write name of family member to whom the update was provided in person",
}

export const PhoneCallNames = {
  [PhoneCall.HAS_BEEN_CALLED]: ({ names }) => {
    if(!names || names === '') {
      return `A phone call was made to a family contact: Primary or second contact was called and an update provided over the phone`;
    }
    return `A phone call was made to a family contact: ${names} was called and an update provided over the phone`;
  },
  [PhoneCall.ATTEMPTED_TO_CALL]: ({ names }) => {
    if(!names || names === '') {
      return `A phone call was made to a family contact: No answer to phone call - called family contact and couldn't reach them`;
    }
    return`A phone call was made to a family contact: No answer to phone call - called ${names} and couldn't reach them`;
  },
  [PhoneCall.CONTACT_VISITING_HOME]: ({ names }) => {
    if(!names || names === '') {
      return `Family contact visiting home - an update provided in person`;
    }
    return`${names} visiting home - an update provided in person`;
  },
  [PhoneCall.NOT_REQUIRED]: ({ names }) => {
    return "Phone call not required";
  },
}

export function getSummaryUpdateName(mainValues: IMainUpdateForm) {
  if(isUpdateHasCustomName(mainValues.update)) {
    return mainValues.viewUpdateName
  } else {
    return mainValues.subCategory
  }
}

export function getEmptySubsection(section: Sections) {
  switch (section) {
    case Sections.Medication_Incidents: return Medication_Incidents_SubSections.Medication_Incidents;
    case Sections.Pain: return Pain_SubSections.Pain;
    case Sections.Vaccination: return Vaccination_SubSections.Vaccination;
    case Sections.Other: return Other_SubSections.Other;
    case Sections.Return_From_Hospital: return Return_From_Hospital_SubSections.Return_From_Hospital;
    case Sections.Nutritional: return Nutritional_SubSections.Nutritional;
    case Sections.Resident_Of_The_Day: return Resident_Of_The_Day_SubSections.Resident_Of_The_Day;
    case Sections.Social: return Social_SubSections.Social;
    case Sections.Monthly_Care_Statement: return Monthly_Care_Statement_SubSections.Monthly_Care_Statement;
  }
}

export function getUpdatePriority(section: Sections, subSection?: SubSections) {
  switch(section) {
    case Sections.Request_For_Items: return UpdatePriorities.Low;
    case Sections.Specialist_Appointment: return UpdatePriorities.Low
    case Sections.Resident_Of_The_Day: return UpdatePriorities.Low;
    case Sections.Physiotherapist: return UpdatePriorities.Low;
    case Sections.Nutritional: return UpdatePriorities.Low;
    case Sections.Return_From_Hospital: return UpdatePriorities.Low;
    case Sections.Wound_Care: {
      if(subSection === Wound_Care_SubSections.Wound_Healed) {
        return UpdatePriorities.Low
      }
      return '';
    }
    case Sections.Social: return UpdatePriorities.Social;
    default: return ''
  }
  return ''
}

export function isDateTimeValue(section: Sections | '', subSection?: SubSections) {
  if(section === Sections.Resident_Of_The_Day) {
    return false
  }
  return true;
}

export function isCanEditDateAndTime(section: Sections | '', subSection?: SubSections) {
  if(section === Sections.Nutritional) {
    return false
  }
  return true;
}